var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reportPostList',_vm._g(_vm._b({ref:"inner",attrs:{"report_id":_vm.report_id,"sns_type":'tiktok',"postValueComponent":_vm.reportPostValueTiktok}},'reportPostList',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }